export default {
  confirmLabel: 'ÐÐº',
  backspaceLabel: 'Ð²Ð¾Ð·Ð²ÑÐ°Ñ Ð½Ð° Ð¾Ð´Ð½Ñ Ð¿Ð¾Ð·Ð¸ÑÐ¸Ñ',
  cancelKeyboardLabel: 'ÐÑÐ¼ÐµÐ½Ð¸ÑÑ ÐºÐ»Ð°Ð²Ð¸Ð°ÑÑÑÑ'
};
